module.exports = __webpack_public_path__ + "img/材料力学6_9_1.8fbd09e7.jpg";